import { AnalyticsTransformer, TrackingData } from '@panamax/app-state';

export const loadDYFPageTraceTransformer: AnalyticsTransformer = (
  trackingData: TrackingData,
) => ({
  event: trackingData.data.attributes?.event,
  order: {
    orderId: trackingData.data.attributes?.order.orderId,
    tandemOrderNumber: trackingData.data.attributes.order.tandemOrderNumber,
    confirmedDeliveryDate:
      trackingData.data.attributes.order.confirmedDeliveryDate,
    requestedDeliveryDate:
      trackingData.data.attributes.order.requestedDeliveryDate,
    errorDetails: JSON.stringify(trackingData.data.attributes?.errorDetails),
  },
  dyfProductCount: trackingData.data.attributes.dyfProductCount,
  inspiredPicksProductCount:
    trackingData.data.attributes.inspiredPicksProductCount,
});
